<template>
  <slot></slot>

  <modal :id="modalId">

    <template v-slot:header>
      <h4 class="modal-title">{{ status === '1' ? 'Activate' : 'Deactivate' }} Messaging Services</h4>
    </template>

    <div class="text-warning text-center">
      <strong>
        Are you sure you want to {{ status === '1' ? 'activate' : 'deactivate' }}
        <strong>{{ checkedIds().length }}</strong> selected messaging service(s)?
      </strong>
    </div>

    <template v-slot:footer>
      <button type="button" class="btn btn-white" @click="hideModal"><i class="fa fa-fw fa-ban"></i> Close</button>

      <form method="POST" :action="action">
        <input type="hidden" name="_token" :value="$csrf_token">
        <input type="hidden" name="_method" value="PATCH">
        <input type="hidden" name="service_ids" :value="checkedIds()">
        <input type="hidden" name="status" :value="status">
        <button type="submit" class="btn btn-warning"><i class="fa fa-fw fa-trash"></i> {{ status === '1' ? 'Activate' : 'Deactivate' }} Services</button>
      </form>
    </template>

  </modal>
</template>

<script>
import HasModal from "../../mixins/HasModal";
import { mapState } from 'pinia'
import { useCheckboxListStore } from "../../../stores/checkboxList"

export default {
  mixins: [HasModal],

  props: {

    // Modal dialog id.
    modalId: {
      type: String,
      default: 'activateMSModal'
    },

    // Form action value.
    action: {
      type: String,
      required: true
    },

    status: {
      type: String,
      required: true
    }
  },

  /**
   * Computed values
   */
  computed: {
    ...mapState(useCheckboxListStore, ['checkedIds']),
  },
}
</script>
